export default __webpack_public_path__ + "static/media/img9.8c628b42.jpeg";